module.exports = {
	"de": {
		"title": "Produkte"
	},
	"en": {
		"title": "Products"
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/overview/locales.json
// module id = 65
// module chunks = 0